import React from 'react';

/**
 * Loading Skeleton Component for WhatsApp Chat
 * Provides a better loading experience with skeleton placeholders
 */
const LoadingSkeleton = () => {
    return (
        <div className="loading-skeleton p-3">
            {/* Date header skeleton */}
            <div className="text-center mb-3">
                <div className="skeleton-date-badge mx-auto"></div>
            </div>

            {/* Message skeletons */}
            {[1, 2, 3, 4, 5].map((index) => (
                <div key={index} className={`message-skeleton mb-3 ${index % 2 === 0 ? 'sent' : 'received'}`}>
                    <div className="skeleton-bubble">
                        <div className="skeleton-text skeleton-text-1"></div>
                        <div className="skeleton-text skeleton-text-2"></div>
                        <div className="skeleton-text skeleton-text-3"></div>
                        <div className="skeleton-time"></div>
                    </div>
                </div>
            ))}

            <style jsx>{`
                .loading-skeleton {
                    animation: pulse 1.5s ease-in-out infinite;
                }

                .skeleton-date-badge {
                    width: 120px;
                    height: 24px;
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: shimmer 1.5s infinite;
                    border-radius: 12px;
                }

                .message-skeleton {
                    display: flex;
                }

                .message-skeleton.sent {
                    justify-content: flex-end;
                }

                .message-skeleton.received {
                    justify-content: flex-start;
                }

                .skeleton-bubble {
                    max-width: 75%;
                    min-width: 200px;
                    padding: 12px;
                    border-radius: 18px;
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: shimmer 1.5s infinite;
                }

                .message-skeleton.sent .skeleton-bubble {
                    border-bottom-right-radius: 4px;
                }

                .message-skeleton.received .skeleton-bubble {
                    border-bottom-left-radius: 4px;
                }

                .skeleton-text {
                    height: 14px;
                    background: rgba(255, 255, 255, 0.8);
                    border-radius: 4px;
                    margin-bottom: 6px;
                }

                .skeleton-text-1 {
                    width: 90%;
                }

                .skeleton-text-2 {
                    width: 75%;
                }

                .skeleton-text-3 {
                    width: 60%;
                }

                .skeleton-time {
                    width: 40px;
                    height: 10px;
                    background: rgba(255, 255, 255, 0.6);
                    border-radius: 4px;
                    margin-top: 4px;
                }

                @keyframes shimmer {
                    0% {
                        background-position: -200% 0;
                    }
                    100% {
                        background-position: 200% 0;
                    }
                }

                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.8;
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .loading-skeleton,
                    .skeleton-date-badge,
                    .skeleton-bubble {
                        animation: none;
                    }
                }
            `}</style>
        </div>
    );
};

export default LoadingSkeleton;